import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('help-center.routes.index'),
        name: 'help-center',
        component: () =>
            import(
                /* webpackChunkName: "help-center" */ '@/views/help-center/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('help-center.breadcrumbs.index'),
                    to: { name: 'help-center' },
                    disable: true,
                },
            ],
            showName: i18n.t('help-center.breadcrumbs.index'),
        },
    },
]
